interface Nivel {
    id: number;
    name: string;
    value: number;
    tipo: string
}

export const Niveles: Nivel[] = [{
    id: 1,
    name: "Inicial",
    tipo: "1,2",
    value: 1
},{
    id: 2,
    name: "Primaria",
    tipo: "1, 2",
    value: 2
},{
    id: 3,
    name: "Secundaria",
    tipo: "1, 3",
    value: 3
}]